var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	4684: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/router", [2,12,2,0], () => (() => (__webpack_require__(/*! @angular/router */ 9661))))),
	1085: () => (loadStrictSingletonVersionCheckFallback("default", "@ngrx/effects", [1,10,0,0], () => (() => (__webpack_require__(/*! @ngrx/effects */ 8760))))),
	1872: () => (loadFallback("default", "@anecdotes/design-system/loaders", () => (Promise.all([__webpack_require__.e("default-node_modules_angular_common_fesm2015_http_js"), __webpack_require__.e("default-webpack_sharing_consume_default_ngx-translate_core_ngx-translate_core"), __webpack_require__.e("default-webpack_sharing_consume_default_anecdotes_design-system_injection-tokens_anecdotes_de-413e84"), __webpack_require__.e("libs_design-system_src_modules_loaders_public_api_ts")]).then(() => (() => (__webpack_require__(/*! @anecdotes/design-system/loaders */ 404))))))),
	120: () => (loadFallback("default", "shared-modules/helpers", () => (Promise.all([__webpack_require__.e("default-libs_shared_environments_src_environment_ts"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("libs_shared_modules_src_helpers_public_api_ts")]).then(() => (() => (__webpack_require__(/*! shared-modules/helpers */ 8622))))))),
	6174: () => (loadFallback("default", "shared-modules/translate-config", () => (Promise.all([__webpack_require__.e("default-node_modules_angular_common_fesm2015_http_js"), __webpack_require__.e("default-webpack_sharing_consume_default_ngx-translate_core_ngx-translate_core"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! shared-modules/translate-config */ 6219))))))),
	5188: () => (loadFallback("default", "@anecdotes/service-worker", () => (__webpack_require__.e("libs_service-worker_src_lib_client_public_api_ts").then(() => (() => (__webpack_require__(/*! @anecdotes/service-worker */ 8453))))))),
	4748: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/animations", [2,12,2,0], () => (() => (__webpack_require__(/*! @angular/animations */ 2458))))),
	2043: () => (loadFallback("default", "@anecdotes/design-system/svg-icons", () => (Promise.all([__webpack_require__.e("default-node_modules_angular_common_fesm2015_http_js"), __webpack_require__.e("default-libs_shared_environments_src_environment_ts"), __webpack_require__.e("default-webpack_sharing_consume_default_anecdotes_utils_anecdotes_utils"), __webpack_require__.e("libs_design-system_src_modules_svg-icons_public_api_ts")]).then(() => (() => (__webpack_require__(/*! @anecdotes/design-system/svg-icons */ 6913))))))),
	4990: () => (loadFallback("default", "@anecdotes/design-system/utils", () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ngx-translate_core_ngx-translate_core"), __webpack_require__.e("default-webpack_sharing_consume_default_anecdotes_utils_anecdotes_utils"), __webpack_require__.e("default-webpack_sharing_consume_default_anecdotes_design-system_injection-tokens_anecdotes_de-413e84"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-bootstrap_ng-bootstrap_ng-bootstrap_ng-bootstrap"), __webpack_require__.e("default-libs_design-system_src_modules_utils_public_api_ts")]).then(() => (() => (__webpack_require__(/*! @anecdotes/design-system/utils */ 2827))))))),
	7867: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/fire", [1,6,1,5], () => (() => (__webpack_require__(/*! @angular/fire */ 5298))))),
	2336: () => (loadFallback("default", "@anecdotes/server-events", () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_pusher-js_pusher-js"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @anecdotes/server-events */ 8045))))))),
	6236: () => (loadStrictSingletonVersionCheckFallback("default", "@ngrx/entity", [1,10,0,0], () => (() => (__webpack_require__(/*! @ngrx/entity */ 5399))))),
	1845: () => (loadStrictSingletonVersionCheckFallback("default", "@ngx-translate/core", [1,13,0,0], () => (() => (__webpack_require__(/*! @ngx-translate/core */ 3828))))),
	9060: () => (loadFallback("default", "@anecdotes/utils", () => (__webpack_require__.e("libs_utils_src_public_api_ts").then(() => (() => (__webpack_require__(/*! @anecdotes/utils */ 7555))))))),
	6628: () => (loadStrictSingletonVersionCheckFallback("default", "@ng-bootstrap/ng-bootstrap", [1,7,0,0], () => (() => (__webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ 5684))))),
	5940: () => (loadFallback("default", "@anecdotes/design-system/injection-tokens", () => (__webpack_require__.e("libs_design-system_src_injection-tokens_public_api_ts").then(() => (() => (__webpack_require__(/*! @anecdotes/design-system/injection-tokens */ 8057))))))),
	9136: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-lottie", [1,6,3,0], () => (() => (__webpack_require__(/*! ngx-lottie */ 3514))))),
	9699: () => (loadStrictSingletonVersionCheckFallback("default", "lottie-web", [1,5,7,9], () => (() => (__webpack_require__(/*! lottie-web */ 1993))))),
	9338: () => (loadFallback("default", "@anecdotes/design-system/buttons", () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_anecdotes_design-system_loaders_anecdotes_design-syst-1e4c13"), __webpack_require__.e("default-libs_design-system_src_modules_buttons_public_api_ts")]).then(() => (() => (__webpack_require__(/*! @anecdotes/design-system/buttons */ 746))))))),
	9028: () => (loadFallback("default", "@anecdotes/design-system/directives", () => (Promise.all([__webpack_require__.e("default-libs_shared_environments_src_environment_ts"), __webpack_require__.e("default-libs_design-system_src_modules_directives_public_api_ts")]).then(() => (() => (__webpack_require__(/*! @anecdotes/design-system/directives */ 8627))))))),
	4118: () => (loadStrictSingletonVersionCheckFallback("default", "ng-circle-progress", [1,1,6,0], () => (() => (__webpack_require__(/*! ng-circle-progress */ 661))))),
	3643: () => (loadFallback("default", "@anecdotes/design-system/pipes", () => (__webpack_require__.e("libs_design-system_src_modules_pipes_public_api_ts").then(() => (() => (__webpack_require__(/*! @anecdotes/design-system/pipes */ 9576))))))),
	8181: () => (loadFallback("default", "@anecdotes/design-system/constants", () => (__webpack_require__.e("libs_design-system_src_constants_public_api_ts").then(() => (() => (__webpack_require__(/*! @anecdotes/design-system/constants */ 2323))))))),
	6470: () => (loadStrictSingletonVersionCheckFallback("default", "uuid", [1,8,3,2], () => (() => (__webpack_require__(/*! uuid */ 9732))))),
	7383: () => (loadStrictSingletonVersionCheckFallback("default", "pusher-js", [1,7,0,0], () => (() => (__webpack_require__(/*! pusher-js */ 1711))))),
	1768: () => (loadFallback("default", "@anecdotes/auth-core", () => (Promise.all([__webpack_require__.e("default-node_modules_angular_common_fesm2015_http_js"), __webpack_require__.e("default-webpack_sharing_consume_default_anecdotes_design-system_svg-icons_anecdotes_design-sy-d41d22"), __webpack_require__.e("default-webpack_sharing_consume_default_ngrx_effects_ngrx_effects"), __webpack_require__.e("default-libs_shared_auth-core_src_public_api_ts")]).then(() => (() => (__webpack_require__(/*! @anecdotes/auth-core */ 2911))))))),
	1361: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core", [2,12,2,0], () => (() => (__webpack_require__(/*! @angular/core */ 1477))))),
	5862: () => (loadStrictSingletonVersionCheckFallback("default", "rxjs", [2,6,6,0], () => (() => (__webpack_require__(/*! rxjs */ 7740))))),
	1114: () => (loadStrictSingletonVersionCheckFallback("default", "tslib", [1,2,3,0], () => (() => (__webpack_require__(/*! tslib */ 3786))))),
	921: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common", [2,12,2,0], () => (() => (__webpack_require__(/*! @angular/common */ 93))))),
	4649: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/compiler", [2,12,2,0], () => (() => (__webpack_require__(/*! @angular/compiler */ 4068))))),
	6953: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/forms", [2,12,2,0], () => (() => (__webpack_require__(/*! @angular/forms */ 9298))))),
	4886: () => (loadStrictSingletonVersionCheckFallback("default", "@ngrx/store", [1,10,0,0], () => (() => (__webpack_require__(/*! @ngrx/store */ 8182))))),
	8967: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/platform-browser", [2,12,2,0], () => (() => (__webpack_require__(/*! @angular/platform-browser */ 4919)))))
};
var initialConsumes = [1361,5862,1114,921,4649,6953,4886,8967];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		4684
	],
	"default-webpack_sharing_consume_default_ngrx_effects_ngrx_effects": [
		1085
	],
	"default-webpack_sharing_consume_default_anecdotes_design-system_loaders_anecdotes_design-syst-1e4c13": [
		1872
	],
	"default-webpack_sharing_consume_default_shared-modules_helpers_shared-modules_helpers": [
		120
	],
	"apps_shell_src_bootstrap_ts": [
		6174,
		5188,
		4748
	],
	"default-webpack_sharing_consume_default_anecdotes_design-system_svg-icons_anecdotes_design-sy-d41d22": [
		2043
	],
	"default-libs_shared_auth-core_src_public_api_ts": [
		4990,
		7867,
		2336,
		6236
	],
	"default-webpack_sharing_consume_default_ngx-translate_core_ngx-translate_core": [
		1845
	],
	"default-webpack_sharing_consume_default_anecdotes_utils_anecdotes_utils": [
		9060
	],
	"default-webpack_sharing_consume_default_ng-bootstrap_ng-bootstrap_ng-bootstrap_ng-bootstrap": [
		6628
	],
	"default-webpack_sharing_consume_default_anecdotes_design-system_injection-tokens_anecdotes_de-413e84": [
		5940,
		9136
	],
	"libs_design-system_src_modules_loaders_public_api_ts": [
		9699
	],
	"default-libs_design-system_src_modules_utils_public_api_ts": [
		9338,
		9028,
		4118,
		3643,
		8181,
		6470
	],
	"default-webpack_sharing_consume_default_pusher-js_pusher-js": [
		7383
	],
	"libs_shared_modules_src_helpers_public_api_ts": [
		1768
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}